import { Component } from "../../core/Component";
import { Whip } from "../../utils/Whip";
import { BatmanHook } from "../BatmanHook";
import { Player } from "../Player";
import PlayerState, { PlayerStateTypes } from "./PlayerState"

export default class PlayerStateBatarang extends PlayerState {

    animComponent?: Component;

    constructor(player: Player, imgPrefix: string) {
        super(player, imgPrefix, PlayerStateTypes.Batarang);
    }

    beginState(): void {
        const character = this.player.character;
        if (character.name.includes("Batman")) this.animComponent = this.player.addComponent(new BatmanHook(this.player, character));
        if (character.name.includes("Wonderwoman")) this.animComponent = this.player.addComponent(new Whip(this.player, character));
        this.player.createSlamIcon();

        super.beginState();
    }

    shutDown(): void {
        super.shutDown();
        this.player.destroySlamIcon();
        if (this.animComponent) this.player.removeComponent(this.animComponent);
    }
}